import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-body mb-n3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col col-3 mb-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "cursor-pointer d-flex align-items-center form-label" }
const _hoisted_7 = ["onChange", "checked", "disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageChunks, (images) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images, (image) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "pt-1 me-2",
                      onChange: ($event: any) => (_ctx.toggleSelectedImage(image)),
                      checked: _ctx.isSelected(image),
                      disabled: !_ctx.isSelected(image) && _ctx.selectedImages.length >= _ctx.maxCount
                    }, null, 40, _hoisted_7),
                    (_ctx.isSelected(image))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_8, "Vybraná"))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Vybraná")
                        ], 64))
                  ])
                ])
              ]),
              _createElementVNode("img", {
                src: image.url,
                onClick: ($event: any) => (_ctx.toggleSelectedImage(image)),
                class: "img-fluid img-thumbnail cursor-pointer"
              }, null, 8, _hoisted_9)
            ]))
          }), 256))
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmSelection())),
        type: "button",
        class: "btn btn-primary"
      }, "Potvrdit vybrané"),
      _cache[1] || (_cache[1] = _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-primary",
        "data-bs-dismiss": "modal"
      }, "Storno", -1))
    ])
  ]))
}